import * as React from "react";
import { SVGProps } from "react";

const AddXyz = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 192 192"
    {...props}
  >
    <linearGradient
      id="a"
      x1={-91.456}
      x2={209.693}
      y1={643.523}
      y2={1058.767}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} />
      <stop offset={1} stopColor="#050606" />
    </linearGradient>
    <circle cx={96} cy={96} r={96} fill="url(#a)" />
    <linearGradient
      id="b"
      x1={97.233}
      x2={87.918}
      y1={868.261}
      y2={848.941}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#b)"
      fillRule="evenodd"
      d="M108.2 59.6 95.9 57l-12.2 2.6L96 45l12.2 14.6z"
      clipRule="evenodd"
    />
    <linearGradient
      id="c"
      x1={108.624}
      x2={87.073}
      y1={884.975}
      y2={859.986}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#c)"
      fillRule="evenodd"
      d="M108.7 59.6 96.9 82l-.9 1.8-12.4-24.2L96 57l12.7 2.6z"
      clipRule="evenodd"
    />
    <linearGradient
      id="d"
      x1={113.47}
      x2={94.673}
      y1={891.832}
      y2={866.603}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#d)"
      fillRule="evenodd"
      d="M122.1 76 96 83.8l12.3-24.1L122.1 76z"
      clipRule="evenodd"
    />
    <linearGradient
      id="e"
      x1={123.161}
      x2={98.463}
      y1={878.628}
      y2={849.062}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#e)"
      fillRule="evenodd"
      d="m125.8 70.8-3.7 5.1L96 45.1l29.8 25.7z"
      clipRule="evenodd"
    />
    <linearGradient
      id="f"
      x1={120.11}
      x2={101.007}
      y1={903.476}
      y2={878.199}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#f)"
      fillRule="evenodd"
      d="M122.1 76 96 83.7l8.1 16.7 18-24.4z"
      clipRule="evenodd"
    />
    <linearGradient
      id="g"
      x1={141.999}
      x2={118.933}
      y1={898.267}
      y2={880.891}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#g)"
      fillRule="evenodd"
      d="M140 100.2 122.1 76l3.8-5.3 14.1 29.5z"
      clipRule="evenodd"
    />
    <linearGradient
      id="h"
      x1={142.424}
      x2={113.094}
      y1={914.844}
      y2={900.638}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#h)"
      fillRule="evenodd"
      d="M122.1 122V76l18 24.3-18 21.7z"
      clipRule="evenodd"
    />
    <linearGradient
      id="i"
      x1={127.895}
      x2={98.527}
      y1={907.747}
      y2={893.572}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#i)"
      fillRule="evenodd"
      d="M122.1 122V75.9l-18 24.4 18 21.7z"
      clipRule="evenodd"
    />
    <linearGradient
      id="j"
      x1={145.832}
      x2={116.972}
      y1={930.94}
      y2={916.132}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#j)"
      fillRule="evenodd"
      d="M140.2 142.6v-42.4L122.1 122l18.1 21.9v-1.3z"
      clipRule="evenodd"
    />
    <linearGradient
      id="k"
      x1={89.225}
      x2={70.428}
      y1={890.477}
      y2={865.248}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#k)"
      fillRule="evenodd"
      d="M69.9 76 96 83.8 83.7 59.6 69.9 76z"
      clipRule="evenodd"
    />
    <linearGradient
      id="l"
      x1={93.191}
      x2={68.493}
      y1={878.759}
      y2={849.194}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#l)"
      fillRule="evenodd"
      d="m66.2 70.8 3.7 5.1L96 45.1 66.2 70.8z"
      clipRule="evenodd"
    />
    <linearGradient
      id="m"
      x1={95.31}
      x2={76.207}
      y1={902.495}
      y2={877.219}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#m)"
      fillRule="evenodd"
      d="M69.9 76 96 83.7l-8.1 16.7-18-24.4z"
      clipRule="evenodd"
    />
    <linearGradient
      id="n"
      x1={70.535}
      x2={47.469}
      y1={900.102}
      y2={882.726}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#n)"
      fillRule="evenodd"
      d="M52 100.2 69.9 76l-3.8-5.3L52 100.2z"
      clipRule="evenodd"
    />
    <linearGradient
      id="o"
      x1={75.65}
      x2={46.32}
      y1={907.785}
      y2={893.579}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#o)"
      fillRule="evenodd"
      d="M69.9 122V76l-18 24.3 18 21.7z"
      clipRule="evenodd"
    />
    <linearGradient
      id="p"
      x1={90.218}
      x2={60.85}
      y1={914.757}
      y2={900.582}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#p)"
      fillRule="evenodd"
      d="M69.9 122V75.9l18 24.4-18 21.7z"
      clipRule="evenodd"
    />
    <linearGradient
      id="q"
      x1={71.814}
      x2={42.954}
      y1={938.319}
      y2={923.511}
      gradientTransform="translate(0 -806)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#46effa" />
      <stop offset={0.937} stopColor="#2000e3" />
    </linearGradient>
    <path
      fill="url(#q)"
      fillRule="evenodd"
      d="M51.8 142.6v-42.4L69.9 122l-18.1 21.9v-1.3z"
      clipRule="evenodd"
    />
  </svg>
);

export default AddXyz;
